module.exports = __webpack_public_path__ + "img/16-full-sm.f93b4715.jpg";